import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

const drawerWidth = 265;

export default ({ transitions }: Theme) =>
  createStyles({
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: 'nowrap',
    },
    drawerOpen: {
      width: drawerWidth,
      transition: transitions.create('width', {
        easing: transitions.easing.sharp,
        duration: transitions.duration.enteringScreen,
      }),
      overflowX: 'hidden',
      boxShadow: '0 6px 6px rgba(0, 0, 0, .2)',
      paddingTop: 48,
      boxSizing: 'border-box',
      '& > ul': {
        paddingBottom: 0,
      },
    },
    drawerClose: {
      transition: transitions.create('width', {
        easing: transitions.easing.sharp,
        duration: transitions.duration.leavingScreen,
      }),
      overflow: 'hidden',
      width: 48,
      boxShadow: '0 6px 6px rgba(0, 0, 0, .2)',
      paddingTop: 48,
      boxSizing: 'border-box',

      '& > ul': {
        paddingBottom: 0,
      },
    },
    drawerCloseMobile: {
      display: 'none',
      transition: transitions.create('width', {
        easing: transitions.easing.sharp,
        duration: transitions.duration.leavingScreen,
      }),
      overflow: 'hidden',
      width: 48,
      boxShadow: '0 6px 6px rgba(0, 0, 0, .2)',
      paddingTop: 48,
      boxSizing: 'border-box',

      '& > ul': {
        paddingBottom: 0,
      },
    },

    itemCurrent: {
      '& .MuiListItemIcon-root': {
        background: palette.primary.main,
        color: palette.white,
      },

      '& .MuiTypography-root': {
        color: palette.primary.main,
      },
    },
    itemCurrentSuperAdmin: {
      '& .MuiListItemIcon-root': {
        background: palette.navSuperAdminActions,
        color: palette.white,
      },

      '& .MuiTypography-root': {
        color: palette.navSuperAdminActions,
      },
    },
    itemCurrentAdmin: {
      '& .MuiListItemIcon-root': {
        background: palette.navAdmin,
        color: palette.white,
      },

      '& .MuiTypography-root': {
        color: palette.navAdmin,
      },
    },
    itemCurrentOperator: {
      '& .MuiListItemIcon-root': {
        background: palette.navOperator,
        color: palette.darkGray,
      },

      '& .MuiTypography-root': {
        color: palette.navOperator,
      },
    },
    menuOptions: {
      padding: '5px 0px 5px 16px',
    },

    listHeader: {
      color: palette.darkGray,
      opacity: 0.5,
      fontSize: 12,
      lineHeight: 3,
    },
    listHeaderClose: {
      fontSize: 12,
      opacity: 1,
      marginLeft: 4,
      lineHeight: 3,
    },
    listItemIcon: {
      background: palette.grey600,
      color: palette.white,
      justifyContent: 'center',
      alignItems: 'center',
      minWidth: 0,
      width: 16,
      height: 16,
      borderRadius: 2,
      marginRight: 12,
      '& svg': {
        fontSize: 12,
      },
    },
    listItemIconSuperAdmin: {
      background: palette.gray,
      color: palette.white,
      justifyContent: 'center',
      alignItems: 'center',
      minWidth: 0,
      width: 16,
      height: 16,
      borderRadius: 2,
      marginRight: 12,
      '& svg': {
        fontSize: 12,
      },
    },
    listItemText: {
      margin: '0',

      '& .MuiTypography-root': {
        fontSize: 12,
        fontWeight: 500,
      },
    },
    hiddenClose: {
      transition: transitions.create('opacity', {
        easing: transitions.easing.sharp,
        duration: transitions.duration.leavingScreen,
      }),
      opacity: 0,
    },
  });
